import { Map } from "immutable";
import { STATE_STATUS, UPDATE_STAGE_CASE } from "constants";

const INITIAL_STATE = new Map({});

export default (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
    case UPDATE_STAGE_CASE.SUCCESS_ASSIGN_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE
        );
    case UPDATE_STAGE_CASE.FAILED_ASSIGN_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case UPDATE_STAGE_CASE.SUCCESS_PROCEED_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATED
        );
    case UPDATE_STAGE_CASE.FAILED_PROCEED_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case UPDATE_STAGE_CASE.SUCCESS_REJECT_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATED
        );
    case UPDATE_STAGE_CASE.FAILED_REJECT_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case UPDATE_STAGE_CASE.SUCCESS_REFER_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATED
        );
    case UPDATE_STAGE_CASE.FAILED_REFER_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE_FAILED
        );

    case UPDATE_STAGE_CASE.SUCCESS_APPROVE_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATED
        );
    case UPDATE_STAGE_CASE.FAILED_APPROVE_CASE:
        return state.setIn(
            [payload.case_task_id, "status"],
            STATE_STATUS.UPDATE_FAILED
        );
    case "LOGOUT":
        return INITIAL_STATE;
    default:
        return state;
    }
};
